export const PRODUCTS_REQUESTED = 'PRODUCTS_REQUESTED'
export const PRODUCTS_RECEIVED = 'PRODUCTS_RECEIVED'
